import { pgTable, text, timestamp, uuid, boolean } from 'drizzle-orm/pg-core';
import { defaultColumns } from './defaultColumns';
import { organisationTable } from './organisation.sql';
import { relations } from 'drizzle-orm';
import { teamTable } from './team.sql';
import { userLocationTable } from './userLocation.sql';
export const locationTable = pgTable('location', {
  id: uuid('id').primaryKey().defaultRandom(),
  name: text('name').notNull(),
  organisationId: uuid('organisationId')
    .notNull()
    .references(() => organisationTable.id),
  deleted: boolean('deleted').notNull().default(false),
  deletedAt: timestamp('deletedAt'),
  notificationEnabled: boolean('notificationEnabled').notNull().default(true),
  ...defaultColumns,
});

export const locationRelations = relations(locationTable, ({ one, many }) => ({
  organisation: one(organisationTable, {
    fields: [locationTable.organisationId],
    references: [organisationTable.id],
  }),
  teams: many(teamTable),
  users: many(userLocationTable),
}));
